import { SelectedSystemType } from 'data/types';
import {
  useGetQuotableSystemRequiredAccessoryOptionsQuery,
  useGetQuotableSystemsQuery
} from 'features/api/project-api';
import { useDuctedAccessoryRecommendations } from 'hooks/use-ducted-accessory-recommendations';

export function useDuctedAccessoriesPageData(system: SelectedSystemType) {
  const recommendationData = useDuctedAccessoryRecommendations(system);
  const { data: requiredOptions, isLoading: isLoadingRequiredOptions } =
    useGetQuotableSystemRequiredAccessoryOptionsQuery(system.uniqueId);
  const { data: quotableSystemsData, isLoading: isLoadingQuotableSystems } =
    useGetQuotableSystemsQuery([system.uniqueId]);

  const savedSystem = quotableSystemsData?.find(
    (row) => row.uniqueId === system.uniqueId
  );

  return {
    ...recommendationData,
    requiredOptions,
    savedSystem,
    isLoading:
      recommendationData.isLoading ||
      isLoadingRequiredOptions ||
      isLoadingQuotableSystems
  };
}
